module.exports = __webpack_public_path__ + "components/country-flag/static/ye-483086833d1f24c21b149089d2a3ee4f.svg";